import styled from "styled-components";

interface ContainerProps {
    src?: string;
}

export const Container = styled.div<ContainerProps>`
    position: fixed;
    z-index: 4;
    width: 100%;
    height: 100vh;
    display: flex;
    background-color: rgba(0,0,0,.4);
    box-shadow: 3px 3px 5px rgba(0,0,0,.1);
    background-size: cover;
    background-position: center;
    overflow: hidden;
`;

export const Content = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;   

`;

export const Image = styled.img<ContainerProps>`

    transition: .5s all;
    overflow: hidden;
    min-width: 200px;
    height: 95%;
    left: 95%;
    right: 95%;
    align-items: center;
    object-fit: contain;
    
    @media (min-width: 576px) {
        max-height: 90%;
        max-width: 80%; 
    }
`;